import { render } from "./StickyNav.vue?vue&type=template&id=1484e120&scoped=true"
import script from "./StickyNav.vue?vue&type=script&lang=js"
export * from "./StickyNav.vue?vue&type=script&lang=js"

import "./StickyNav.vue?vue&type=style&index=0&id=1484e120&lang=scss"
import "./StickyNav.vue?vue&type=style&index=1&id=1484e120&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1484e120"]])

export default __exports__